import { makeStyles } from '@material-ui/core'

// Custom styles
export const useStyles = makeStyles((theme) => ({
  root: {
    padding: '20px 30px',
    margin: 'auto',
    backgroundColor: theme.palette.background.paper,
    marginBottom: 20,
    marginTop: 20,
    borderRadius: 4
  },
  row: {
    marginBottom: theme.spacing(1)
  },
  label: {
    fontWeight: 'bold',
    color: theme.palette.grey[500]
  },
  value: {
    color: theme.palette.text.primary
  }
}))
